import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import messages from '../constants/messages';
import { Books } from '../components/books';
import { LoaderSpinner } from '../components/loaderAndSpinners';
import { ROUTES } from '../constants';
import { addBasketItem } from '../redux/reducers/basketReducer';
import { useScrollTop } from '../helpers/useScrollTop';

export const validator = (variant, images, covers) => {
  if (variant.max && images.length > variant.max) return messages.tooMuchFoto;
  if (variant.min && images.length < variant.min) return messages.tooLessFoto;
  if (covers.length > 4) return messages.tooMuchCover;
  return '';
};

export const MainElemRender = () => {
  useScrollTop();
  const dispatch = useDispatch();
  const { page } = useParams();
  const history = useHistory();
  const [loader, setLoader] = useState({ showLoader: false, showAnswer: '' });
  const closeLoader = () => setLoader({ showAnswer: '', showLoader: false });

  const { images, coverImages } = useSelector(state => state.pictures.uploadedPictures);

  const addToBasket = (data, variant, id = new Date().getTime()) => {
    const showAnswer = validator(variant, images, coverImages);
    if (showAnswer) {
      setLoader({ showLoader: true, showAnswer });
      return;
    }
    const basketItem = {
      numberOfCopies: data.numberOfCopies,
      images,
      type: variant.type,
      orientation: variant.orientation,
      size: variant.size,
      coverImages,
      comment: data.comment,
      productType: page,
      id,
      productId: variant.id,
      productTypeId: variant.productTypeId,
      price: variant.price,
      shilda: variant.shilda,
      cover: variant.cover,
      wishes: variant.wishes,
      min: variant.min,
      max: variant.max,
    };
    dispatch(addBasketItem(basketItem));
    history.push(ROUTES.BASKET);
  };

  const defaultProp = {
    title: ({ min, max }) =>
      min && max
        ? `Добавьте ${min === max ? min : `от ${min} до ${max}`} фотограф${max % 10 === 1 ? 'ию' : 'ий'}`
        : null,
    hasComment: false,
    hasCopies: true,
    hasCover: false,
    has_from_to: false,
    addToBasket,
  };

  const booksIn = {
    fotobooks: {
      ...defaultProp,
      hasComment: true,
      hasCover: true,
    },
    calendars: defaultProp,
    photos: defaultProp,
    gifts: defaultProp,
    postcards: {
      ...defaultProp,
      has_from_to: true,
    },
    decor: defaultProp,
    magnets: defaultProp,
    souvenirs: defaultProp,
    clothes: defaultProp,
    certificates: defaultProp,
  };

  return (
    <>
      <LoaderSpinner showLoader={loader.showLoader} showAnswer={loader.showAnswer} closeLoader={closeLoader} />
      <Books booksIn={booksIn[page] || {}} setLoader={setLoader} />
    </>
  );
};
